module.exports = __webpack_public_path__ + "img/instagram-logo-black.6a67416f.svg";